module.exports = __webpack_public_path__ + "media/images/university_logos/University-of-St-Andrews-c266aa18e0a9d58b5e68c3993b362e74.svg";